// 签单 - 合作商
import request from '@/tool/request'
const c = 'SignShop/';

// 获取面单打印的token
export function shippinglabelToken(query) {
  return request({
    url: c+'shippinglabelToken',
    method: 'post',
    data:query
  })
}

/********************************* 分组管理 *********************************/
// 添加分组
export function groupAdd(query) {
  return request({
    url: c+'groupAdd',
    method: 'post',
    data:query
  })
}
// 分组列表
export function groupList(query) {
  return request({
    url: c+'groupList',
    method: 'post',
    data:query
  })
}
// 删除分组
export function groupDel(query) {
  return request({
    url: c+'groupDel',
    method: 'post',
    data:query
  })
}

/********************************* 签单管理 *********************************/
// 订单列表
export function orderList(query) {
  return request({
    url: c+'orderList',
    method: 'post',
    data:query
  })
}
// 订单添加
export function orderAdd(query) {
  return request({
    url: c+'orderAdd',
    method: 'post',
    data:query
  })
}

// 订单添加 - 批量
export function orderAddBatch(query) {
  return request({
    url: c+'orderAddBatch',
    method: 'post',
    data:query,
	timeout: 0, // 这个接口设置不超时
  })
}

// 解析面单
export function docAnalysis(query) {
  return request({
    url: c+'docAnalysis',
    method: 'post',
    data:query
  })
}

/********************************* 充值 *********************************/
// 获取系统设置
export function getSysSet(query) {
  return request({
    url: c+'getSysSet',
    method: 'post',
    data:query
  })
}
// 充值提交
export function recharge(query) {
  return request({
    url: c+'recharge',
    method: 'post',
    data:query
  })
}
// 充值明细
export function rechargeList(query) {
  return request({
    url: c+'rechargeList',
    method: 'post',
    data:query
  })
}
// 资金明细
export function brList(query) {
  return request({
    url: c+'brList',
    method: 'post',
    data:query
  })
}
// 获取excel导出的token
export function excelToken(query) {
  return request({
    url: c+'excelToken',
    method: 'post',
    data:query
  })
}
// 解析excel数据
export function doExcel(query) {
  return request({
    url: c+'doExcel',
    method: 'post',
    data:query
  })
}

/********************************* Excel面单上传 *********************************/
// 获取基础数据
export function excelDocInit(query) {
  return request({
    url: c+'excelDocInit',
    method: 'post',
    data:query
  })
}